import { hot } from "react-hot-loader";

import React, { useEffect, useState } from "react";
import { bool } from "prop-types";

import showingTimeUrls from "../../services/urlService";
import * as S from "./styled";

const AgentConfigurationLink = props => {
  const [agentConfigurationUrl, setAgentConfigurationUrl] = useState(null);

  useEffect(() => {
    const fetchAgentConfigurationUrl = async () => {
      const url = await showingTimeUrls.generateAgentConfigurationUrl();
      setAgentConfigurationUrl(url);
    };
    fetchAgentConfigurationUrl();
  }, []);

  return (
    agentConfigurationUrl && (
      <S.AgentLink
        href={agentConfigurationUrl}
        rel="nofollow noopener noreferrer"
        target="_blank"
        {...props}
      >
        ShowingTime
        <S.LinkOutIcon />
        <S.CallOut>New</S.CallOut>
      </S.AgentLink>
    )
  );
};

AgentConfigurationLink.propTypes = {
  agent_dropdown: bool
};
AgentConfigurationLink.defaultProps = {
  agent_dropdown: false
};

export default hot(module)(AgentConfigurationLink);
